var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearchTagQuestionBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.64043 8.00059C3.64043 5.68099 5.52083 3.80059 7.84043 3.80059C10.16 3.80059 12.0404 5.68099 12.0404 8.00059C12.0404 8.8982 11.7588 9.73006 11.2792 10.4126L9.8356 9.1491C9.58625 8.93085 9.20719 8.95607 8.98894 9.20542C8.7707 9.45476 8.79591 9.83383 9.04526 10.0521L10.4561 11.2869C9.73847 11.8588 8.82936 12.2006 7.84043 12.2006C5.52083 12.2006 3.64043 10.3202 3.64043 8.00059ZM11.3704 12.0872C10.4238 12.9056 9.18993 13.4006 7.84043 13.4006C4.85809 13.4006 2.44043 10.9829 2.44043 8.00059C2.44043 5.01825 4.85809 2.60059 7.84043 2.60059C10.8228 2.60059 13.2404 5.01825 13.2404 8.00059C13.2404 9.20099 12.8487 10.3099 12.1862 11.2065L12.8214 11.7624C13.0707 11.9807 13.0959 12.3598 12.8777 12.6091C12.6594 12.8585 12.2804 12.8837 12.031 12.6654L11.3704 12.0872Z",
    fill: "black",
    fillOpacity: 0.87
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchTagQuestionBlack);
export default __webpack_public_path__ + "static/media/icon_search_tag_question_black.b9689ef495846f982d4e337c3385b31c.svg";
export { ForwardRef as ReactComponent };